<template>
	<div>
		<div class="container hidden-xs">
			<b-breadcrumbs :items="breadcrumbs"/>
		</div>
		<delete-modal
			:show-modal="showDeleteModal"
			:details="currentRegulation"
			@closeDeleteModal="hideDeleteModal"
			@delete="deleteRegulation"
		/>
		<section class="container">
			<div class="row">
				<div class="col-xs-12 col-xs-8">
                    <h1>Projects</h1>
					<div class="page-summary-container">
						<div class="page-summary-text">
							Add, edit &amp; delete projects
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-sm-6">
					<div class="input-group">
						<input
							v-model="searchTerm"
							type="text"
							class="form-control"
							style="height:40.25px;"
							placeholder="Search projects"
							@keyup.enter="search"
						>
						<span class="input-group-btn">
							<b-btn class="btn-primary" @click="search">
								<i class="material-icons">search</i>
							</b-btn>
						</span>
					</div>
				</div>
				<div class="col-xs-6 col-sm-3">
					<b-btn
						class="btn-primary btn-md btn-block btn-filter-admin collapsed"
						data-toggle="collapse"
						aria-expanded="false"
						@click="showFilters=!showFilters"
					>
					Filter
					</b-btn>
				</div>
				<div class="col-xs-6 col-sm-3">
					<router-link
						to="/admin/projects/new"
						class="btn btn-success btn-md btn-block btn-filter-admin"
						data-toggle="collapse"
						aria-expanded="false"
						role="button"
					>
					Add new
					</router-link>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<filtering
						:showFilters="showFilters"
						:filter-options="filterOptions"
						:sort-options="sortOptions"
						:selected-filters="selectedFilters"
						@resetSearchTerm="setSearchTerm(null)"
						@selectedOptions="applyFilters"
					/>
				</div>
			</div>
			<template v-if="loading">
				<div class="row">
					<div class="col-xs-12">
						<div class="container loading-container">
							<img class="section-loader" src="@/assets/images/fse_reg-section-loader-admin.gif"/>
						</div>
					</div>
				</div>
			</template>
			<template v-else-if="regulations && regulations.length > 0">
				<div
					v-for="regulation in regulations"
					:key="regulation.id"
					class="list-container list-container-notifications"
				>
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
							<template v-if="regulation.clients.length > 0" >
								<div class="sm-padding-bottom-10">
									<b-btn
										v-for="client in regulation.clients"
										:key="client.id"
										class="label label-success"
										@click="appendAndApplyFilter('clients', client.id)"
									>
										&nbsp;{{ client.name }}&nbsp;
									</b-btn>
								</div>
							</template>
							<template v-else>
								<div class="sm-padding-bottom-10">
									<span class="label label-default">No clients set</span>
								</div>
							</template>
							<div class="no-margin">{{ formatStartDate(regulation.start_date) }}</div>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
							<div class="sm-padding-bottom-10">
								<div class="notification-list-heading">
									<router-link
										:to="`/project/${regulation.id}`"
									>
										{{ regulation.title }}
									</router-link>
								</div>
							</div>
						</div>
						<div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
							<div>
								<b-btn
									v-for="region in regulation.regions"
									:key="region.id"
									class="label label-info"
									@click="filterAndSearch('regions', region.id)"
								>
									&nbsp;{{ region.name }}&nbsp;
								</b-btn>
								<!--
								<br/>
								<b-btn
									v-for="tag in regulation.tags"
									:key="tag.id"
									class="label label-secondary"
									@click="filterAndSearch('tags', tag.id)"
								>
									&nbsp;{{ tag.name }}&nbsp;
								</b-btn>
								-->
							</div>
						</div>
						<div class="col-xs-12 col-sm-4 col-md-1 col-lg-1">
							<b-dropdown class="btn-group">
								<b-btn class="btn btn-primary btn-sm dropdown-toggle" style='height: auto;'>
									Actions
									<span class="form-label sr-only">Toggle Dropdown</span>
								</b-btn>
								<template slot="dropdown" class="dropdown-l-r">
									<li>
										<router-link
											:to="`/admin/projects/${regulation.id}`"
											role="button"
										>
											Edit
										</router-link>
									</li>
									<li>
										<a
											@click="showDeleteModal=true; openDeleteModal(regulation)"
											role="button"
										>Delete</a>
									</li>
								</template>
							</b-dropdown>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="row">
					<div class="col-xs-12">
						<div class="container center">
							<h2>No results found</h2>
						</div>
					</div>
				</div>
			</template>
			<div class="row">
				<div class="col-xs-12">
					<div class="pagination-container">
						<b-pagination
							v-if="pagination && pagination.totalPages > 1"
							v-model="pagination.page"
							:total-page="pagination.totalPages"
						/>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="less" scoped>
	.input-group {
		margin-bottom: 30px;
	}
	.btn-primary {
		height: 40.25px;
	}
	.loading-container {
		text-align: center;
	}
	.section-loader {
		max-width: 200px;
		height: auto;
		margin: 30px auto;
	}

	.dropdown-menu-l-r {
		left: 0;
		right: auto;
		@media (min-width: 768px){
			left: auto;
			right: 0;
		}
	}
</style>

<script>
import moment from 'moment';
import filtering from '@/components/filtering';
import deleteModal from '@/components/delete-modal';
import { map, flow, filter, orderBy } from 'lodash/fp';
import { Notification } from 'uiv';
import { mapGetters } from 'vuex';
import { determineNextPageOnDelete } from '@/modules/utils';

export default {
	components: { filtering, deleteModal },
	created() {
		this.getRegulations();
		this.getRegulationFilterOptions();
	},
	data() {
		return {
			showFilters: false,
			searchTerm: null,
			regulations: null,
			filterOptions: {},
			sortOptions: [],
			pagination: {
				page: 1
			},
			options: null,
			showDeleteModal: false,
			currentRegulation: {
				id: null,
				name: null
			},
			selectedSortOrder: null,
			selectedFilters: {
				clients: [],
				regions: [],
				status: [],
				dates: [],
				tags: []
			},
			loading: false
		};
	},
	methods: {
		openDeleteModal(regulation) {
			this.currentRegulation.name = regulation.title;
			this.currentRegulation.id = regulation.id;
		},
		hideDeleteModal() {
			this.showDeleteModal = false;
		},
		formatStartDate(startDate) {
			const date = moment(startDate).format('DD/MM/YYYY');

			if (date === 'Invalid date') {
				return 'In progress';
			}
			return `Completed: ${date}`;
		},
		async getRegulations(params) {
			this.loading = true;
			const { searchTerm, selectedSortOrder, selectedFilters } = this;
			const { data: { data: regulations, pagination } } = await this.$axios.get('/resource', {
				params: {
					searchTerm,
					sortBy: selectedSortOrder,
					page: this.pagination.page,
					...selectedFilters,
					...params
				}
			});
			this.$set(this, 'regulations', regulations);
			this.$set(this, 'pagination', pagination);
			this.loading = false;
		},
		async getRegulationFilterOptions() {
			const { data: { data: options } } = await this.$axios.get('/resource/filter-options');

			const formattedSortOptions = map(({ code, name }) => ({
				value: code, label: name
			}), options.sortOptions);

			const formattedIssues = flow(
				map(({ id, name }) => ({
					value: id,
					label: name
				})),
				orderBy('label', 'asc')
			)(options.filterOptions.clients);

			const formattedStatus = map(({ id, name }) => ({
				value: id, label: name
			}), options.filterOptions.status);

			const formattedDates = flow(
				filter(value => value !== 'Invalid date'),
				map(value => ({ value, label: value	}))
			)(options.filterOptions.dates);

			const formattedTags = map(({ id, name }) => ({
				value: id, label: name
			}), options.filterOptions.tags);

			const formattedRegions = map(({ id, name }) => ({
				value: id, label: name
			}), options.filterOptions.regions);

			this.$set(this, 'sortOptions', formattedSortOptions);
			this.$set(this, 'filterOptions', {
				clients: formattedIssues,
				status: formattedStatus,
				dates: formattedDates,
				tags: formattedTags,
				regions: formattedRegions
			});
		},
		async deleteRegulation(id) {
			await this.$axios.delete(`/resource/${id}`);
			// if this is the last item in a page, render the previous page; current page limit is 20
			const page = determineNextPageOnDelete(this.pagination, 20);
			this.getRegulations({ page });

			this.hideDeleteModal();
			Notification.notify({
				type: 'danger',
				title: 'Project deleted',
				content: `Successfully deleted ${this.currentRegulation.name}.`,
				duration: 10000
			});
		},
		async applyFilters(options) {
			this.$set(this, 'selectedSortOrder', options.selectedSortOrder);
			this.$set(this, 'selectedFilters', options.selectedFilters);
			await this.getRegulations({ page: 1 });
		},
		async search() {
			await this.getRegulations({ page: 1 });
		},
		async setSearchTerm(term) {
			this.$set(this, 'searchTerm', term);
			await this.getRegulations({ page: 1 });
		},
		resetFilters() {
			this.selectedFilters = {
				regions: [],
				clients: [],
				status: [],
				dates: [],
				tags: [],
			};
		},
		async appendAndApplyFilter(type, id) {
			this.resetFilters();
			this.$set(this.selectedFilters, type, [id]);
			await this.getRegulations({ page: 1 });
		}
	},
	computed: {
		...mapGetters({ getBreadcrumbs: 'breadcrumbs' }),
		breadcrumbs() {
			return this.getBreadcrumbs;
		}
	},
	watch: {
		'pagination.page': async function pageWatcher() {
			await this.getRegulations();
		},
	},
};
</script>
